module.exports = __webpack_public_path__ + "img/armenia.4171bc1d.svg";